/*
 * @Author: liujian
 * @Description: 
 * @Date: 2021-09-14 15:03:53
 * @LastEditTime: 2022-02-25 18:51:49
 * @FilePath: /three-class-fe-1/src/config/constant.ts
 */
export const USER_LOGIN_COOKIE = 'WEBSSID'

export const LOCAL_USER_INFO = 'USER_INFO_WEBPAGE'